import imageOne from '../images/house-8.jpg';
import imageTwo from '../images/home-interior-2.jpg';

export const InfoData = {
    heading: 'Chácara no pé da Serra, com piscina e jacuzzi aquecida!!!!',
    paragraphOne: 'A Chácara e um ambiente que possui muita paz e indicado para quem que sair do ritmo agitado da cidade, com vista para as montanhas, e muito verde. A casa e rústica com área ao redor aconchegante .Possui piscina e jacuzzi, área grande de gramado, possui um mercadinho 2 km e vinícola próximo, se precisar de guia fico a disposição.',
    paragraphTwo: 'Será dado apoio aos hóspedes para o manejo das instalações caso haja dúvidas, temos caseiro nas proximidades .',
    buttonLabel: 'View Homes',
    image: imageOne,
    reverse: false,
    delay: 100
};

export const InfoDataTwo = {
    heading: 'Explore our beautful homes',
    paragraphOne: 'Aute quis aliquip Lorem laboris deserunt ex dolore culpa cillum eiusmod. Adipisicing excepteur ipsum ipsum culpa cupidatat laborum dolor sint fugiat laborum commodo. Dolore consectetur dolore veniam est nostrud nostrud cupidatat anim veniam aliqua eiusmod occaecat aliqua.',
    paragraphTwo: 'Lorem cupidatat laborum fugiat anim proident ullamco in sit sint elit tempor eu ut. Ea aliquip aute quis aliqua do nostrud quis nostrud nostrud consequat',
    buttonLabel: 'View Homes',
    image: imageTwo,
    reverse: true,
    delay: 300
}